<template>
  <div class="cart">
    <div class="cart-title" @click="onShow">
      <i class="el-icon-shopping-cart-2"></i
      ><span>{{ $t("B2C.shopCart") }}</span>
      <i class="el-icon-arrow-down" v-if="show"></i>
      <i class="el-icon-arrow-up" v-else></i>
    </div>
    <div class="cart-container" v-if="show">
      <div class="cart-content">
        <div v-if="content && content.length > 0">
          <div class="product" v-for="(product, index) in content" :key="index">
            <div class="product-left">
              <div
                class="image"
                @click="toDetail(product.ProductNumber, product.ShopId)"
              >
                <el-image
                  :src="imgUrlFilter(product.ProductPhoto)"
                  fit="cover"
                ></el-image>
              </div>
              <div class="qty">
                <el-button
                  size="mini"
                  @click="inputNumberChange(product, false)"
                  ><i class="el-icon-minus"></i
                ></el-button>
                <el-input
                  size="mini"
                  v-model="product.Number"
                  @input="handleInput($event, product)"
                ></el-input>
                <el-button size="mini" @click="inputNumberChange(product, true)"
                  ><i class="el-icon-plus"></i
                ></el-button>
              </div>
            </div>
            <div
              class="product-right"
              @click="toDetail(product.ProductNumber, product.ShopId)"
            >
              <div class="productName">
                <div class="discount" v-if="product.IsCouponProduct">
                  {{ $t("B2C.discount") }}
                </div>
                <div class="brand" v-if="product.IsBrandProduct">
                  {{ $t("B2C.brand") }}
                </div>
                <div class="attestation" v-if="product.IsAttestationProduct">
                  {{ $t("B2C.attestation") }}
                </div>
                <div class="name">{{ product.ProductName }}</div>
              </div>
              <div class="modelName">
                {{ product.ProductModelStr }}
              </div>
              <div class="notice" v-if="product.IsUser == 0">
                <span v-if="product.ProductState == 2"
                  >( {{ $t("B2C.inventoryState1") }} )</span
                >
                <span v-if="product.ProductState == 3"
                  >( {{ $t("B2C.inventoryState2") }} )</span
                >
                <span v-if="product.ProductState == 4"
                  >( {{ $t("B2C.productOff") }} )</span
                >
              </div>
            </div>

            <div class="product-btns">
              <el-button
                icon="el-icon-close"
                size="mini"
                circle
                @click="onDelete(product.UCId)"
              ></el-button>
            </div>
          </div>
        </div>
        <div class="cart-empty" v-else>
          <el-empty
            :description="$t('basket.noData')"
            :image-size="100"
          ></el-empty>
        </div>
      </div>
      <div class="cart-footer">
        <el-button
          class="submit-button"
          type="warning"
          @click="handleSubmit"
          :disabled="content && content.length == 0 ? true : false"
          >{{ $t("basket.submit") }}</el-button
        >
        <el-button
          class="clear-button"
          @click="onClear"
          :disabled="content && content.length == 0 ? true : false"
          >{{ $t("basket.clear") }}</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "shopCart",
  props: {},
  components: {},
  data() {
    return {
      show: false,
      content: [],
    };
  },
  created() {
    var bus = this.$bus.$off("showCart");
    if (bus) {
      bus.$on("showCart", (val) => {
        this.show = val.show;
        if (this.isLogin() && this.loginType() == "C") {
          this.getShoppingCart();
        }
      });
    }
  },
  mounted() {
    this.auth = JSON.parse(localStorage.getItem("auth")) || {};
  },
  methods: {
    loginType() {
      return this.auth.type;
    },
    isLogin() {
      return this.$store.getters.isLogging;
    },
    handleInput(value, product) {
      if (value < 1) {
        product.Number = 1;
      }
      if (value > product.Inventory) {
        product.Number = product.Inventory;
      }
    },
    inputNumberChange(product, isPlus) {
      if (product.Number <= 1 && !isPlus) {
        return;
      }
      if (product.Number >= product.Inventory && isPlus) {
        return;
      }
      const param = {
        ShopId: product.ShopId,
        ProductNumber: product.ProductNumber,
        ProductModelStr: product.ProductModelStr,
        ProductModel: product.ProductModel,
        ShopMoney: product.ShopMoney,
        Number: isPlus ? 1 : -1,
      };
      this.$api.shopCar
        .addShopCar(param)
        .then(() => {
          if (isPlus) {
            product.Number = product.Number + 1;
          } else {
            product.Number = product.Number - 1;
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value.split("|")[0]);
    },
    getShoppingCart() {
      const param = {
        PageIndex: 1,
        PageSize: 999,
      };
      this.$api.shopCar
        .loadShopCarByPage(param)
        .then((res) => {
          this.content = res.data || [];
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    onClear() {
      var list = [];
      for (const item of this.content) {
        list.push(item.UCId);
      }
      const param = {
        UCIdList: list.join("|"),
      };
      this.$api.shopCar
        .deleteShopCarByList(param)
        .then(() => {
          this.getShoppingCart();
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    onDelete(id) {
      const param = {
        UCIdList: id,
      };
      this.$api.shopCar
        .deleteShopCarByList(param)
        .then(() => {
          this.getShoppingCart();
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    onShow() {
      this.show = !this.show;
      if (this.show) {
        if (this.isLogin() && this.loginType() == "C") {
          this.getShoppingCart();
        }
      }
    },
    toDetail(ProductNumber, ShopId) {
      let routeUrl = this.$router.resolve({
        path: "/details",
        query: { ProductNumber: ProductNumber, ShopId: ShopId },
      });
      window.open(routeUrl.href, "_blank");
    },
    handleSubmit() {
      let arr = [];
      let offArr = [];
      for (const product of this.content) {
        if (product.IsUser == 1 && product.Number <= product.Inventory) {
          arr.push({
            UCId: product.UCId,
            ProductNumber: product.ProductNumber,
            Number: product.Number,
            ShopId: product.ShopId,
            ProductModel: product.ProductModel,
            ProductModelStr: product.ProductModelStr,
          });
        } else {
          offArr.push({
            ProductName: product.ProductName,
          });
        }
      }
      if (offArr.length > 0) {
        var prod = [];
        for (const item of offArr) {
          prod.push(item.ProductName);
        }

        this.$message.error(
          JSON.stringify(prod) + " , " + this.$t("B2C.productsOff")
        );
        return;
      }

      let routeUrl = this.$router.resolve({
        path: "/order",
        query: { Products: JSON.stringify(arr) },
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.cart {
  z-index: 99;
  width: 374px;
  position: fixed;
  right: 5%;
  bottom: 0;
  text-align: center;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 5px 10px;
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
  .cart-title {
    color: #fff;
    border-top-left-radius: 25px;
    border-top-right-radius: 25px;
    background: rgb(89, 89, 91);
    font-size: 17px;
    line-height: 44px;
    cursor: pointer;
    i {
      margin-right: 5px;
    }
    span {
      margin-right: 5px;
    }
  }
  .cart-container {
    background: #fff;
    .cart-content {
      height: 500px;
      overflow-y: scroll;
      padding-bottom: 20px;
      .product:first-child {
        margin-top: 15px !important;
      }
      .product {
        margin-top: 30px;
        cursor: pointer;
        .product-left {
          width: 35%;
          vertical-align: middle;
          display: inline-block;
          .image {
            margin-bottom: 10px;
            .el-image {
              width: 70px;
              height: 70px;
              .el-image__error {
                font-size: 10px;
              }
            }
          }
          .qty {
            .el-input {
              font-size: 12px;
              width: 35px;
              margin: 0px 5px;
              ::v-deep .el-input__inner {
                text-align: center;
                padding: 0;
              }
            }
            .el-button {
              padding: 5px;
              vertical-align: middle;
            }
          }
        }
        .product-right {
          width: 55%;
          vertical-align: middle;
          display: inline-block;

          .productName {
            font-size: 14px;
            margin-bottom: 5px;
            .discount {
              vertical-align: middle;
              display: inline-block;
              background: red;
              color: white;
              padding: 0px 2px;
              border-radius: 2px;
              font-size: 12px;
              margin-right: 5px;
            }
            .brand {
              vertical-align: middle;
              display: inline-block;
              background: #e6a23c;
              color: white;
              padding: 0px 2px;
              border-radius: 2px;
              font-size: 12px;
              margin-right: 5px;
            }
            .attestation {
              vertical-align: middle;
              display: inline-block;
              background: #22b196;
              color: white;
              padding: 0px 2px;
              border-radius: 2px;
              font-size: 12px;
              margin-right: 5px;
            }
            .name {
              display: inline-block;
              vertical-align: middle;
            }
          }
          .modelName {
            color: #aaaaaa;
            font-size: 14px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .notice {
            color: red;
            font-size: 12px;
            font-weight: bold;
            margin-top: 10px;
          }
        }
        .product-btns {
          width: 10%;
          vertical-align: middle;
          display: inline-block;
          .el-button {
            border: none;
            font-size: 20px;
            i {
              font-weight: bold;
            }
          }
        }
      }
    }
    .cart-footer {
      width: 100%;
      padding: 3%;
      text-align: center;
      border-top: 1px solid rgb(204, 204, 204);
      .submit-button {
        font-size: 14px;
        border-radius: 10px;
        padding: 10px 50px;
        background: linear-gradient(270.13deg, #f58603 0.13%, #fb3f04 99.91%);
      }
      .clear-button {
        font-size: 14px;
        border-radius: 10px;
        padding: 10px 50px;
        background: rgb(204, 204, 204);
        color: #333;
      }
    }
    .cart-empty {
      display: block;
      text-align: center;
      width: 100%;
      margin-bottom: 20px;
      color: #999;
      ::v-deep .el-empty {
        margin-top: 30%;
        margin-bottom: 30%;
        .el-empty__image {
          margin: auto;
        }
        p {
          font-size: 14px;
          color: #999;
        }
      }
    }
  }
}
</style>
